// stores/itemStore.js
import { create } from "zustand";
import axios from "axios";
import authHeader from "../../services/auth-header";
import { APP_URL } from "../../services/http-common";
import useGlobalStore from "./globalStoreZs";

const URLEntityName = APP_URL + "users";

const useUserProfileStore = create((set, get) => ({
  userIdZs: {},
  getUserByIdZs: async (id) => {
    set({ loading: true });
    useGlobalStore.getState().setLoadingZs(true);
    try {
      const response = await axios.get(URLEntityName + "/" + id, {
        headers: authHeader(),
      });
      set({
        userIdZs: response.data,
      });
    } catch (error) {
      console.error("Error fetching user", error);
    }
    set({ loading: false });
    useGlobalStore.getState().setLoadingZs(false);
  },

  updateUserByIdZs: async (item) => {
    set({ loading: true });
    useGlobalStore.getState().setLoadingZs(true);
    try {
      const response = await axios.put(URLEntityName + "/" + item?.id, item, {
        headers: authHeader(),
      });
      //   await useFormInputesSubmissionStore.getState().getReportZs(item?.id);
      await useUserProfileStore.getState().getUserByIdZs(item?.id);
      useGlobalStore.getState().setLoadingZs(false);
      useGlobalStore.getState().setMessageZs("Profili u ndryshuar me sukses!");
    } catch (error) {
      console.error("Error fetching items", error);
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      useGlobalStore.getState().setMessageZs(message);
    }
    useGlobalStore.getState().setLoadingZs(false);
    set({ loading: false });
  },
}));

export default useUserProfileStore;
